module.exports = __webpack_public_path__ + "static/home-hero-2-1d8054e9c932b7ba7b758c89b72681ac.jpg";